'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _button = require('@alicd/next/lib/button');

var _button2 = _interopRequireDefault(_button);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _icon = require('@alicd/next/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconButton = function (_React$Component) {
  (0, _inherits3.default)(IconButton, _React$Component);

  function IconButton() {
    (0, _classCallCheck3.default)(this, IconButton);
    return (0, _possibleConstructorReturn3.default)(this, (IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(IconButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          iconType = _props.iconType,
          style = _props.style,
          children = _props.children,
          other = (0, _objectWithoutProperties3.default)(_props, ['iconType', 'style', 'children']);

      var style1 = {
        padding: '0 7px'
      };

      if (other.size === 'small') {
        style1 = {
          padding: '0 5px'
        };
      } else if (other.size === 'large') {
        style1 = {
          padding: '0 9px'
        };
      }

      if (style) {
        (0, _assign2.default)(style1, style);
      }
      return _react2.default.createElement(
        _button2.default,
        (0, _extends3.default)({}, other, { style: style1 }),
        _react2.default.createElement(_icon2.default, { type: iconType }),
        ' ',
        children
      );
    }
  }]);
  return IconButton;
}(_react2.default.Component);

IconButton.propTypes = {
  iconType: _propTypes2.default.string,
  size: _propTypes2.default.string,
  style: _propTypes2.default.object
};
IconButton.defaultProps = {
  size: 'medium'
};
exports.default = IconButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-icon-button@0.0.8@@alicd/crui-icon-button/lib/IconButton.js
// module id = 638
// module chunks = 0